import React, { useEffect, useState } from 'react'
import { auth } from "../../firebase/firebase-config";
import firebase from "../../firebase/firebase-config";
import { useAuthState } from 'react-firebase-hooks/auth';

// reactstrap components
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardText,
    FormGroup,
    Form,
    Input,
    Row,
    Col
} from "reactstrap";
import { useParams } from 'react-router-dom';

const SingleUserProfile = () => {
    const params = useParams();
    console.log(params.id);
    const [user, loading] = useAuthState(auth);
    const [user_data, setUser_data] = useState({});
    const [user_followers, setuser_followers] = useState(0);
    const [user_followings, setuser_followings] = useState(0);
    useEffect(() => {
        GetMyUser();


    }, [])


    async function GetMyUser() {
        const ref = await firebase.firestore().collection('users').doc(params.id).onSnapshot((snapshot) => {
            console.log(snapshot.data());
            return setUser_data(snapshot.data());

        })
        const followers = await firebase.firestore().collection('followers').doc(params.id).collection('userFollowers').onSnapshot((snapshot) => {

            return setuser_followers(snapshot.size);

        })
        const followings = await firebase.firestore().collection('following').doc(params.id).collection('userFollowing').onSnapshot((snapshot) => {

            return setuser_followings(snapshot.size);

        })

    }


    return (
        <>
            <div className="content ">
                <Row className="shadow-lg" style={{ borderRadius: '12px' }}>
                    <Col md="8">
                        <Card>
                            <CardHeader className="d-flex justify-content-between align-items-center">
                                <h5 className="title">Edit Profile </h5>

                                {user_data?.isOnline == false ? <div className="px-4 d-flex justify-content-center align-items-center  font-weight-bolder" style={{ backgroundColor: '#DD011B', borderRadius: '20px' }}> <p className='font-weight-bold'>Ofline</p>    </div> : <div className="px-4 d-flex justify-content-center align-items-center " style={{ backgroundColor: '#30DF1E', borderRadius: '20px' }}> <p className="font-weight-bold">Online</p>    </div>}


                            </CardHeader>
                            <CardBody>
                                <Form>
                                    <Row>
                                        <Col className="pr-md-1" md="5">
                                            <FormGroup>
                                                <label>Company (disabled)</label>
                                                <Input
                                                    defaultValue="Beyown Fashion & designing Co."
                                                    disabled
                                                    placeholder="Company"
                                                    type="text"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col className="px-md-1" md="3">
                                            <FormGroup>
                                                <label>Username</label>
                                                <Input
                                                    defaultValue={user_data?.username}
                                                    placeholder="Username"
                                                    type="text"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col className="pl-md-1" md="4">
                                            <FormGroup>
                                                <label htmlFor="exampleInputEmail1">
                                                    Email address
                                                </label>
                                                <Input placeholder="user email address" type="email" defaultValue={user_data?.email} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="pr-md-1" md="6">
                                            <FormGroup>
                                                <label>Full Name</label>
                                                <Input
                                                    defaultValue={user_data?.fullName}
                                                    placeholder="Company"
                                                    type="text"
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col className="pl-md-1" md="6">
                                            <FormGroup>
                                                <label>Contact Number</label>
                                                <Input
                                                    defaultValue={user_data?.contact}
                                                    placeholder="Last Name"
                                                    type="text"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md="12">
                                            <FormGroup>
                                                <label>Date of birth</label>
                                                <Input
                                                    defaultValue={user_data?.dob}
                                                    placeholder="User DOB"
                                                    type="text"
                                                    value={user_data?.dob}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md="12">
                                            <FormGroup>
                                                <label>Address</label>
                                                <Input
                                                    defaultValue=''
                                                    placeholder="Home Address"
                                                    type="text"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="pl-md-1" md="4">
                                            <FormGroup>
                                                <label>State</label>
                                                <Input placeholder="State " type="text" />
                                            </FormGroup>
                                        </Col>
                                        <Col className="pr-md-1" md="4">
                                            <FormGroup>
                                                <label>City</label>
                                                <Input
                                                    defaultValue='dsa'
                                                    placeholder="City"
                                                    type="text"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col className="px-md-1" md="4">
                                            <FormGroup>
                                                <label>Country</label>
                                                <Input
                                                    defaultValue='dsa'
                                                    placeholder="Country"
                                                    type="text"
                                                />
                                            </FormGroup>
                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col md="8">
                                            <FormGroup>
                                                <label>About Me</label>
                                                <Input
                                                    // cols="80"
                                                    defaultValue={user_data?.bio == '' ? 'There is no bio' : user_data?.bio}
                                                    placeholder="Here can be your description"
                                                    rows="4"
                                                    type="textarea"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="pr-md-1" md="4">
                                            <FormGroup>
                                                <label>Email Verified</label>
                                                <Input
                                                    defaultValue={user_data?.isEmailVerified}
                                                    placeholder=""
                                                    type="text"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col className="px-md-1" md="4">
                                            <FormGroup>
                                                <label>Private Account</label>
                                                <Input
                                                    defaultValue={user_data?.isPrivate}
                                                    placeholder="Country"
                                                    type="text"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col className="pl-md-1" md="4">
                                            <FormGroup>
                                                <label>Login Sources</label>
                                                <Input placeholder='' defaultValue={user_data?.loginSource} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Form>
                            </CardBody>
                            <CardFooter>
                                <Button className="btn-fill" color="primary" type="submit">
                                    Save
                                </Button>
                            </CardFooter>
                        </Card>
                    </Col>
                    <Col md="4">
                        <Card className="card-user shadow-lg">

                            <CardBody>
                                <CardText />

                                <div className="author">

                                    <div className="block block-one" />
                                    <div className="block block-two" />
                                    <div className="block block-three" />
                                    <div className="block block-four" />

                                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                                        <img
                                            alt="..."
                                            className="avatar"
                                            src={user_data?.profilePicture}
                                        />


                                        <h5 className="title">@{user_data?.username}</h5>
                                    </a>

                                    <p className="description">Beyown User</p>
                                    <div className="d-flex justify-content-around align-items-center">
                                        <p className="font-weight-bolder">Followers: {user_followers == 0 ? 0 : user_followers} </p>
                                        <p className="font-weight-bolder">Followings: {user_followings == 0 ? 0 : user_followings} </p>

                                    </div>
                                </div>
                                <div className="card-description">
                                    {user_data?.bio == '' ? 'There is no bio' : user_data?.bio}
                                </div>
                            </CardBody>
                            <CardFooter>
                                <div className="button-container">
                                    <Button className="btn-icon btn-round" color="facebook">
                                        <i className="fab fa-facebook" />
                                    </Button>
                                    <Button className="btn-icon btn-round" color="twitter">
                                        <i className="fab fa-twitter" />
                                    </Button>
                                    <Button className="btn-icon btn-round" color="google">
                                        <i className="fab fa-google-plus" />
                                    </Button>
                                </div>
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default SingleUserProfile